import { PUB_SUB_EVENTS } from '../base/constants';
import { subscribe } from '../base/pubsub';

/**
 * Manages free shipping threshold messaging in the cart drawer.
 * Since the threshold text is now rendered server-side, this module
 * primarily handles any dynamic updates that might be needed.
 */
class FreeShippingThreshold {
  constructor() {
    this.thresholdValue = 0;
    this.leftMessage = '';
    this.rightMessage = '';
    this.completeMessage = '';
    this.thresholdElement = null;

    this.init();
  }

  /**
   * Initialises the free shipping threshold functionality.
   */
  init() {
    // Get settings from window object.
    const settings = window.freeShippingSettings;
    if (!settings) {
      return;
    }

    this.thresholdValue = settings.thresholdValue;
    this.leftMessage = settings.leftMessage;
    this.rightMessage = settings.rightMessage;
    this.completeMessage = settings.completeMessage;

    // Subscribe to cart updates for any additional dynamic updates if needed.
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      // The threshold text is now rendered server-side, so no JavaScript updates needed
    });

    // Also listen for custom cart-updated events.
    document.addEventListener('cart-updated', () => {
      // The threshold text is now rendered server-side, so no JavaScript updates needed
    });
  }

  /**
   * Clean up event listeners.
   */
  destroy() {
    // No cleanup needed since we're not doing dynamic updates anymore
  }
}

// Initialize the free shipping threshold functionality.
document.addEventListener('DOMContentLoaded', () => {
  new FreeShippingThreshold();
});

export default FreeShippingThreshold;
